module.exports = __webpack_public_path__ + "img/login-lalibertad.9b79f396.svg";